<template>
	<div>
		<button v-tooltip.bottom-center="{ content: content.helpToolTip }" class="btn help" data-tour-item="help"
			tabindex="0" @click="toggleHelpComponent" v-bind="config.attrs"  :class="{inFocus : showHelp}">
			<svg role="img" width="24px" height="24px" viewBox="0 0 24 24" fill="none"
				xmlns="http://www.w3.org/2000/svg" aria-labelledby="helpIcon">
				<path fill-rule="evenodd" clip-rule="evenodd"
					d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.58584 14.3415 10.232 13.883 10.704C13.7907 10.7989 13.7027 10.8869 13.6187 10.9708C13.4029 11.1864 13.2138 11.3753 13.0479 11.5885C12.8289 11.8699 12.75 12.0768 12.75 12.25V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V12.25C11.25 11.5948 11.555 11.0644 11.8642 10.6672C12.0929 10.3733 12.3804 10.0863 12.6138 9.85346C12.6842 9.78321 12.7496 9.71789 12.807 9.65877C13.0046 9.45543 13.125 9.18004 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z"
					fill="#545454" />
			</svg>
			<!-- <svg v-else role="img" height="34px" version="1.1" viewBox="0 0 34 34" width="34px"
				xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-labelledby="helpIcon">
				<title id="helpIcon">Help Icon</title>
				<g id="Tutorial---Tool-tips" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
					<g id="Help---Vertical-Scrolling" transform="translate(-1179.000000, -23.000000)">
						<g id="icon-help-red" transform="translate(1179.000000, 23.000000)">
							<rect id="Rectangle-Copy-5" fill="currentColor" height="33" rx="4" stroke="" width="33" x="0.5"
								y="0.5"></rect>
							<path id="icon-help"
								d="M17,9 C12.584,9 9,12.584 9,17 C9,21.416 12.584,25 17,25 C21.416,25 25,21.416 25,17 C25,12.584 21.416,9 17,9 Z M17.8,22.6 L16.2,22.6 L16.2,21 L17.8,21 L17.8,22.6 Z M19.456,16.4 L18.736,17.136 C18.16,17.72 17.8,18.2 17.8,19.4 L16.2,19.4 L16.2,19 C16.2,18.12 16.56,17.32 17.136,16.736 L18.128,15.728 C18.424,15.44 18.6,15.04 18.6,14.6 C18.6,13.72 17.88,13 17,13 C16.12,13 15.4,13.72 15.4,14.6 L13.8,14.6 C13.8,12.832 15.232,11.4 17,11.4 C18.768,11.4 20.2,12.832 20.2,14.6 C20.2,15.304 19.912,15.944 19.456,16.4 Z"
								fill="#FFFFFF" fill-rule="nonzero"></path>
						</g>
					</g>
				</g>
			</svg> -->
			<span>{{ content.helpBtn }}</span>
		</button>

	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import featureMixin from "@/mixins/featureMixin";
import Lytics from "@/classes/Lytics";

export default {
	name: "HelpButtonV2",
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'helpScreen.toggleButton'
		}
	},
	computed: {
		...mapGetters(['content']),
		...mapState('toast', ['showHelp'])
	},
	methods: {
		...mapActions('toast', ['toggleHelp']),

		toggleHelpComponent() {
			console.log('Toggle Help');
			this.toggleHelp();
			this.$parent.isHidden = !this.$parent.isHidden
			Lytics.TriggerHelpClick();
		}
	}
}
</script>

<style lang="scss" scoped>
div {
	display: inline-flex;
	align-items: center;

	.btn.help {
		padding: 0;
		cursor: pointer;
		border: none;
		background: none;
		flex-direction: row;

		svg {
			margin-left: 3px;
		}
	}
}


.btn.help:hover>*, .btn.inFocus > *{
	color: var(--secondary-color);
}

.btn.inFocus {
   svg {
	path {
		fill: var(--secondary-color);
	}
   }
}
</style>
